module.exports = __webpack_public_path__ + "public/img/towerCrane.5c742a07.png";